/**
 * 撤稿指令管理
 * Bai.Zhiming
 * 2019-7-2
 */
angular.module('withdrawalMgtModule', ['withdrawalMgtRouterModule', 'withdrawalMgtServiceModule']).controller('withdrawalMgtCtrl', [
    '$scope',
    'withdrawalMgtService',
    '$q',
    'modalDialog',
    'globleParamsSet',
    'trsHttpService',
    'editcenterRightsService',
    function($scope, withdrawalMgtService, $q, modalDialog, globleParamsSet, trsHttpService, editcenterRightsService) {
        initStatus();
        initData();
        $scope.requestData = requestData;

        /**
         * [fullTextSearch description] 检索
         * @param  {[type]} $event [description] 事件
         * @return {[type]}        [description]
         */
        $scope.fullTextSearch = function($event) {
            if ($event && $event.keyCode !== 13) {return;}
            $scope.status.isSearch = !!$scope.status.keywords;
            requestData();
        };

        /**
         * [finish description] 进入详情
         * @param  {[type]} $event [description] 稿件信息
         * @return {[type]} [description]
         */
        $scope.toDetail = function(item) {
            let params = {
                serviceid: 'mlf_pm',
                methodname: 'getDocuments',
                ids: item.docid,
            };
            $scope.loadingPromse = httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                item = !angular.isArray(resp) || resp.length == 0 ? item : angular.extend(item, resp[0]);
                withdrawalMgtService.detail(item).then(() => {
                    modalDialog.alertType('确定已经完成指令要求的撤稿内容吗？', '', 'ask', true, () => {
                        finish(item.docid);
                    });
                });
            });
        };

        /**
         * [finish description] 完成
         * @param  {[type]} item [description] 稿件信息
         * @return {[type]}      [description]
         */
        $scope.finish = function(item) {
            modalDialog.alertType('确定已经完成指令要求的撤稿内容吗？', '', 'ask', true, () => {
                finish(item.docid);
            });
        };

        /**
         * [finish description] 完成
         * @param  {[type]} id [description] 稿件id
         * @return {[type]}    [description]
         */
        function finish(id) {
            let params = {
                serviceid: 'mlf_pm',
                methodname: 'finishRetractionsDoc',
                docIds: id,
            };
            $scope.loadingPromse = httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                modalDialog.alertType('该稿件已完成撤稿', '', 'success', false, requestData);
            });
        }

        /**
         * [jumpToPage description] 跳页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                statusOptions: [
                    {
                        name: '全部',
                    },
                    {
                        name: '已完成',
                        value: 1,
                    },
                    {
                        name: '未完成',
                        value: 2,
                    },
                    {
                        name: '已完成已超时',
                        value: 3,
                    },
                    {
                        name: '未完成已超时',
                        value: 4,
                    },
                ],
                btnRights: {},
            };
            $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {};
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // 依据初始化按钮
            editcenterRightsService.initIwoListBtn('iwo.withdraw').then(function(rights) {
                $scope.status.btnRights = rights;
            });
            requestData();
        }

        /**
         * [handleParams description] 处理参数
         * @return {[type]} [description]
         */
        function handleParams() {
            return {
                serviceid: 'mlf_pm',
                methodname: 'getRetractionsDocList',
                status: $scope.status.selectedStatus.value,
                startTime: $scope.status.endDate ? $scope.status.startDate + ' 00:00:00' : '',
                endTime: $scope.status.endDate ? $scope.status.endDate + ' 23:59:59' : '',
                searchValue: $scope.status.isSearch ? $scope.status.keywords : '',
                pageIndex: $scope.page.CURRPAGE - 1,
                pageSize: $scope.page.PAGESIZE,
            };
        }

        /**
         * [handlePage description] 处理分页
         * @return {[type]} [description]
         */
        function handlePage(resp) {
            $scope.page = {
                CURRPAGE: resp.page + 1,
                PAGESIZE: resp.size,
                ITEMCOUNT: resp.totalElements,
                PAGECOUNT: resp.totalPages,
            };
            $scope.status.copyCurrPage = resp.page + 1;
        }

        /**
         * [requestData description] 初始化数据
         * @return {[type]} [description]
         */
        function requestData() {
            let params = handleParams();
            $scope.loadingPromise = httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.items = resp.content;
                handlePage(resp);
            });
        }

        /**
         * [httpServer description] 封装http请求
         * @param  {[type]} url    [description] 请求地址
         * @param  {[type]} params [description] 请求参数
         * @param  {[type]} method [description] 方法
         * @return {[type]}        [description]
         */
        function httpServer(url, params, method, forbidden) {
            let deffer = $q.defer();
            trsHttpService.httpServer(url, params, method, forbidden).then(
                (resp) => {
                    if (!angular.isObject(resp)) {
                        deffer.resolve(resp);
                    } else if (resp.CODE == '200') {
                        deffer.resolve(resp.DATA);
                    } else if (resp.CODE != '200') {
                        if (!forbidden) {
                            modalDialog.alertType(resp.MESSAGE, '', 'error', 'confirm', () => {
                                deffer.reject();
                            });
                        } else {
                            deffer.reject();
                        }
                    }
                },
                () => {
                    deffer.reject();
                }
            );
            return deffer.promise;
        }
    },
]);
